import { createReducer } from "@reduxjs/toolkit";
import { GetInvoiceHistory, GetInvoiceItems, GetsearchInvoiceDeliver } from "./invoiceThunk";

const handleAsyncActions = (builder, action, stateKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[stateKey] = true; 
            state[stateKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[stateKey] = false; 
            state[stateKey] = action.payload; 
            if(stateKey === 'InvoiceHistory'){
                localStorage.setItem('PAGEData', `${action.payload[0]?.status}`)
                // sessionStorage.setItem('deliveryHistory', JSON.stringify(action.payload))
            }
            if(stateKey === 'InvoiceItems') {               
                sessionStorage.setItem('Items', JSON.stringify(action.payload))
            }
            state.error[errorKey] = null; 
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[stateKey] = false; 
            state.error[errorKey] = action.payload; 
        });
};

const initialState = {
    InvoiceHistory: null,
    InvoiceItems:null,
    searchInvoiceDeliver:null,
    loading: {
        InvoiceHistory: false,
        InvoiceItems:false,
        searchInvoiceDeliver:false,
    },

    error: {
        InvoiceHistoryError: null,
        InvoiceItemsError:null,
        searchInvoiceDeliverError:null,
        
    },
};

export const InvoiceHistoryReducer = createReducer(initialState, (builder) => {
    handleAsyncActions(builder, GetInvoiceHistory, "InvoiceHistory", "InvoiceHistoryError");
    handleAsyncActions(builder, GetInvoiceItems, "InvoiceItems", "InvoiceItemsError");
    handleAsyncActions(builder, GetsearchInvoiceDeliver, "searchInvoiceDeliver", "searchInvoiceDeliverError");

  
    
});

export default InvoiceHistoryReducer;
